import { asyncPostRequest } from './requests';

export const postPolygonAndGetGeohashes = async (polygons, commit) => {
  return await asyncPostRequest('/coverage/polygons_coverage', { polygons, commit }, true);
};

export const getPolygons = async polygonNames => {
  return await asyncPostRequest('/coverage/polygons', { polygonNames }, true);
};
